import React from "react";
import { useI18n } from "@/i18n";
import { useReveal } from "@/hooks/useReveal";

export default function Waitlist() {
  const { t } = useI18n();
  const rev = useReveal();

  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="relative py-24 md:py-36 bg-neutral-950 text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 20%, rgba(201,168,106,0.22) 0%, rgba(10,10,10,0) 70%)",
        }}
      />
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 relative">
        <div
          ref={rev.ref}
          className={`reveal ${rev.visible ? "is-visible" : ""} max-w-3xl mx-auto text-center`}
        >
          <div className="text-[11px] tracking-[0.24em] uppercase text-neutral-400 mb-5">
            <span
              className="inline-block w-6 h-px align-middle mr-3"
              style={{ background: "#c9a86a" }}
            />
            {t.waitlist.eyebrow}
          </div>
          <h2
            data-testid="waitlist-title"
            className="font-display text-[34px] sm:text-[44px] md:text-[60px] leading-[1.05] tracking-[-0.02em] font-light"
          >
            {t.waitlist.title}
          </h2>
          <p className="mt-5 text-neutral-300 text-[15px] md:text-[17px] max-w-xl mx-auto leading-relaxed">
            {t.waitlist.sub}
          </p>
          <div className="mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/login"
              className="rounded-full px-8 py-4 text-[14px] tracking-wide font-medium transition-all duration-300"
              style={{ background: "#c9a86a", color: "#0a0a0a" }}
            >
              Inizia gratis
            </a>
            <a
              href="#pricing"
              className="rounded-full px-8 py-4 text-[14px] tracking-wide border border-white/20 text-white hover:border-white/40 transition-all duration-300"
            >
              Vedi i piani
            </a>
          </div>
          <p className="mt-6 text-[12px] tracking-[0.14em] uppercase text-neutral-500">
            Nessuna carta richiesta · Piano Free disponibile
          </p>
        </div>
      </div>
    </section>
  );
}
